/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;



//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-line/~/lodash/identity.js
// module id = ./node_modules/victory-brush-line/node_modules/lodash/identity.js
// module chunks = 1